import Apps from '@/core/Apps'
import backendService from 'PatientTravel/services/backendService'
import { mapActions } from 'vuex'
import swal from 'sweetalert'
import { Directions } from 'PatientTravel/enums'

export const patientTravelMixin = {
    methods: {
        countBookingRequisitions(booking) {
            let count = 0
            let requisitions = booking.travel_requisitions

            if (requisitions?.[Directions.FROM_APPOINTMENT]) {
                count ++
            }
            if (requisitions?.[Directions.TO_APPOINTMENT]) {
                count ++
            }
            return count
        },
        bookingHasRequisitions(booking) {
            return this.countBookingRequisitions(booking) > 0
        },
        canCreateRequisitionsForBooking(booking) {
            return this.countBookingRequisitions(booking) < 2
        },
        bookingRequiresTravelRequisition(booking) {
            if (!booking?.client?.requires_patient_travel) {
                return false
            }
            return this.canCreateRequisitionsForBooking(booking)
        },
    },
    computed: {
        isPatientTravelActive() {
            return this.$store.getters['apps/isAppEnabled'](Apps.PatientTravel)
        },
        requisitionNumberTo() {
            return this?.booking?.travel_requisitions?.to || false
        },
        requisitionNumberFrom() {
            return this?.booking?.travel_requisitions?.from || false
        }
    },
}

export const validationMixin = {
    data() {
        return {
            fieldsToValidate: [],
        }
    },
    methods: {
        validateRequisition(form) {
            return backendService.validateRequisition(form)
                .catch(({ errorBag }) => {
                    this.$setErrorBag(errorBag)
                })
        },
        formIsValid() {
            if (!(this.fieldsToValidate.length || null)) {
                return true
            }

            if (!this.errors?.items?.length) {
                return true
            }

            return !this.errors.items.some(err =>
                this.fieldsToValidate.includes(err.field)
            )
        },
    },
}

export const treatmentSiteMixin = {
    methods: {
        ...mapActions('patientTravel', [
            'fetchOffice',
        ]),
        setTreatmentSite(treatmentSite) {
            // Take phone number and remove any white space
            let phone = treatmentSite.phone.replace(/\s+/g, '')
            delete treatmentSite.phone

            // Check if the phone number is exactly 8 digits and does not start with '+'
            if (/^\d{8}$/.test(phone)) {
                treatmentSite.phone = `+47 ${phone}`
            } else if (phone) {
                // Add the phone number as note
                const notes = `${trans('global.phone_number')}: ${phone}`
                treatmentSite.addressNotes = notes
            }

            this.form.treatmentSite = {
                ...this.form.treatmentSite,
                ...treatmentSite
            }

            // office is dependent on treatment site
            this.fetchOffice(treatmentSite?.address?.postcode)
                .catch(() => {
                    swal({
                        title: trans('modules.PatientTravel.requisition_office_error'),
                        text: trans('modules.PatientTravel.types_not_guaranteed_desc'),
                        type: 'info',
                        showCancelButton: false,
                        confirmButtonText: trans('global.ok_button'),
                    })
                })

            this.$event_bus.$emit('checkRequisitionErrors')
        },
    },
}
